<div class="media-item__container">
  <div *ngIf="img" class="media-item__wrapper" [ngStyle]="{'background-image': 'url(' + img + ')'}"></div>
  <mat-icon *ngIf="!img" class="media-item__wrapper">library_music</mat-icon>
  <div class="media-item__info">
    <div class="media-item__title" [title]="title">{{title}}</div>
    <div class="media-item__sub" [title]="subTitle">{{subTitle}}</div>
  </div>
</div>
